<template>
  <div id="app" :class="[className]">
    <!--<div class="absolute" style="z-index: 1000;">-->
      <!--{{$t('login.space')}}-->
      <!--<w-button size="small" @click="changeLang('cn')">中文</w-button>-->
      <!--<w-button size="small" @click="changeLang('en')">英文</w-button>-->
    <!--</div>-->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <!--<Upload/>-->
    <UploadComponent/>
  </div>
</template>
<script>
import {dcostUrl} from "assets/js/config";
import loadingBar from '@zjy/zjy-ui/lib/loading-bar'
// import {projectInfo} from 'service/App';
// import Upload from '@/components/common/Upload/Index.vue'
import {Upload as UploadComponent} from '@/components/Upload'
import {mapState, mapMutations} from 'vuex'
import queryString from 'querystring'
import { getCookie } from '@/assets/utils/CommonUtil'
import permissionService from '@/assets/service/permission'
// import {loadLanguageAsync} from "@/assets/setup/i18n-setup"

export default {
  name: 'app',
  components: {
    // Upload
    UploadComponent
  },
  data () {
    return {
      isLoading: false,
      env: process.env.NODE_ENV,
      beforeUnloadFn: null,
      unloadFn: null,
      className: ''
    }
  },
  computed: {
    ...mapState({
      isMicro: state => state.menus.isMicro
    })
  },
  watch: {
    isLoading (val) {
      if (val) {
        console.log(loadingBar)
        loadingBar.start()
      } else {
        this.$nextTick(() => {
          loadingBar.end()
        })
      }
    },
    $route: {
      handler: function (val, oldVal) {
        if (val && val !== oldVal) {
          this.goToGeipIframe(val)
        }
      },
      deep: true,
      immediate: true
    }
  },
  beforeDestroy () {
    this.initBeforeUnload()
  },
  mounted () {
    this.initBeforeUnload(true)
    // 打印 广材网合并 价格库、指标库 相关iframe地址
    // const gldjc = require('./assets/js/testData/gldjc').default
    // gldjc.print('src')
    // gldjc.print('srcTest')

    // 打印格式化后的 埋点统计json
    // const formatDic = require('./assets/js/logExcel/formatDic').default
    // const group = require('./assets/js/logExcel/allBase')
    // formatDic.printJson(group)

    // 获取语言，并设置
    let browserLanguage = (navigator.language || navigator.browserLanguage).toLowerCase()
    if (browserLanguage.indexOf('zh') > -1) {
      this.setLang('cn')
    } else if (browserLanguage.indexOf('en') > -1) {
      this.setLang('en')
      this.className = 'english'
    } else {
      //
    }
  },
  methods: {
    // changeLang(lang) {
    //   loadLanguageAsync(lang);
    // },
    ...mapMutations({
      setLang: 'SET_LANG_STATE'
    }),
    // 初始化 刷新、关闭窗口事件
    initBeforeUnload (init) {
      if (window.onbeforeunload) {
        window.onbeforeunload = null
      }
      if (window.onunload) {
        window.onunload = null
      }
      if (init) {
        const userAgent = navigator.userAgent
        const fn = () => {
          // console.log(this.hasUploadTask)
          // console.log('-----------')
          const msg = '该操作将会导致中断正在上传的任务，您是否确定?'
          if (window.event && this.hasUploadTask &&
              this.$route.path !== '/index' &&
              this.$route.path !== '/vip' &&
              this.$route.path !== '/download') {
            // 有上传任务正在执行， 并且当前页面不是 /index、/vip、/download
            const n = window.event.screenX - window.screenLeft
            const b = n > document.documentElement.scrollWidth - 20
            if ((b && window.event.clientY < 0) || window.event.altKey) {
              window.event.returnValue = (msg)
            } else {
              return (msg)
            }
          }
        }
        // ie、chrome、360: 刷新时先执行onbeforeload()，新页面即将替换旧页面时onunload()，最后unload();
        // 关闭时执行onbeforeload()，再执行onunload().
        window.onbeforeunload = fn
        if (userAgent.indexOf('Firefox') > -1) {
          // firefox: 刷新时只执行onunload(); 关闭时只执行onbeforeunload()
          window.onunload = fn
        }
      }
    },
    // 跳转到嵌套的项管iframe
    async goToGeipIframe (route) {
      const { path = '' } = route
      const geipToken = getCookie('GEIPTOKEN')
      const tenantId = getCookie('tenantId')
      console.log(window.location)
      if(window.location.href.includes('menuCode=gccs.zjy-app.zjy_module_project_zsxmk_wcyd') && geipToken){
        let url = `${dcostUrl}#/?menuCode=dcost.module.xmzsj.xmhkb&pageFrom=zjy&local_token=${geipToken}`
        console.log('跳转到新成本的url',url)
        // window.open(url)
        window.location.href = url
        return
      }
      if (this.isMicro || path === '/iframePortal' || path === '/index' || path === '/free-license' || path === '/' || path.includes('preview') || geipToken === 'undefined' || !geipToken){
        return
      }
      const findMenuCode = (path) => {
        let toMenuCode = ''
        switch (path) {
          case '/project/joined/list': // 项目库
            toMenuCode = 'gccs.zjy-app.zjy_module_project_zsxmk_wcyd'
            break
          case '/space/database/inventory': // 员工资料库、清单数据
            toMenuCode = 'gccs.zjy-app.zjy_module_ygzlk_ygsj_qd'
            break
          case '/space/database/quota': // 员工资料库、定额数据
            toMenuCode = 'gccs.zjy-app.zjy_module_ygzlk_ygsj_de'
            break
          case '/space/database/material': // 员工资料库、人材机数据
            toMenuCode = 'gccs.zjy-app.zjy_module_ygzlk_ygsj_rcj'
            break
          case '/space/database/combination': // 员工资料库、组件数据
            toMenuCode = 'gccs.zjy-app.zjy_module_ygzlk_ygsj_zj'
            break
          case '/enterprise/share': // 共享空间
            toMenuCode = 'gccs.zjy-app.zjy_module_gxzlk_gxzl'
            break
          case '/manage/members': // 人员管理
            toMenuCode = 'gccs.zjy-app.zjy_module_sqzx_rygl'
            break
          case '/manage/records': // 操作记录
            toMenuCode = 'gccs.zjy-app.zjy_module_sqzx_czjl'
            break
          case '/space/files/list': // 个人文件库
            toMenuCode = 'gccs.zjy-app.zjy_module_gr_gcgl_grwjk'
            break
          case '/workbench/index': // 工作台
          case '/workbench': // 工作台
            toMenuCode = 'gccs.zjy-app.zjy_module_workbench_qysjkb'
            break
          case '/home':
            toMenuCode = 'home'
            break
          default:
            toMenuCode = ''
        }
        return toMenuCode
      }
      let menuCode = findMenuCode(path)
      try {
        const data = await this.getTenantInfo(tenantId)
        const { categoryCodes = null } = JSON.parse(data)
        if (categoryCodes && categoryCodes.includes('personal')) {
          menuCode = 'gccs.zjy-app.zjy_module_gr_gcgl_grwjk'
        }
      } catch (e) {
        console.log(e)
      }
      // 跳转到协同页面
      if (/^\/iframe\//.test(path)) {
        if (decodeURIComponent(path).includes('coop') || path.includes('coop')){
          let linkUrl = decodeURIComponent(route.params.linkUrl)
          const obj = {}
          if (route.query) {
            for (const key in route.query) {
              if (!(['linkUrl'].includes(key))) {
                obj[key] = route.query[key]
              }
            }
          }
          let index = linkUrl.indexOf('?')
          if (index > -1) {
            // 2021.3.15 新增--开始
            // weburl中存在带#号，若有需要编码
            let queryParams = queryString.decode(linkUrl.substring(index + 1))
            if (queryParams.weburl && queryParams.weburl.indexOf('#') > -1) {
              linkUrl = `${linkUrl.substring(0, index)}?weburl=${encodeURIComponent(queryParams.weburl)}`
              delete queryParams.weburl
              for (let key in queryParams) {
                linkUrl += `&${key}=${queryParams[key]}`
              }
              // let weburl = `weburl=${encodeURIComponent(queryParams.weburl)}`
              // delete queryParams.weburl
              // linkUrl = `${linkUrl.substring(0, index)}?${weburl}&${queryString.stringify(queryParams)}`
            }
            // 2021.3.15 新增--结束
            linkUrl += '&'
          } else {
            linkUrl += '?'
          }
          linkUrl += queryString.stringify(obj)
          const regex = /\/coop\/#(.*)/ // 正则表达式匹配coop之后的任意字符
          const match = linkUrl.match(regex)
          const linkUrlPath = match ? match[1] : ''
          linkUrlPath && localStorage.setItem('linkUrlPath', linkUrlPath)
          menuCode = 'gccs.zjy-app.zjy_module_zjxz_xmxz'
        }
      }
      if (menuCode) {
        // localStorage.setItem('hasReloaded', true)
        this.$router.push({
          path: '/iframePortal',
          query: { menuCode }
        })
      }
    },
    getTenantInfo (tenantId){
      return new Promise((resolve, reject) => {
        permissionService.getTenantInfo(tenantId).then(res => {
          if (+res.code === 200 && res.data) {
            const data = res.data
            resolve(data)
          } else {
            resolve({})
          }
        }).catch((e) => {
          reject(e)
        })
      })
    }
  }
}
</script>
<style lang="less">
  @import "./assets/less/common.less";
  @import "./assets/less/table.less";

  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    width: 100%;
    height: 100%;
  }
  .w__message--item {
    color: rgba(33, 37, 48, 0.8) !important;
    padding-right: 24px !important;
  }
  .w__select {
    display: inline-table !important;
  }

  .w__select__tags > span {
    display: block;
    word-break: break-all;
    max-width: 100%;
  }

  thead th {
    text-align: center;
  }

  // button {
  //   [class*=" w-icon-"], [class^=w-icon-], [class*=" r2-icon-"], [class^=r2-icon-] {
  //     font-size: 12px !important;
  //   }
  // }
  body .w__submenu .w__menu-item, body .w__menu-item, body .w__submenu__title{
    height: 44px;
    line-height: 44px;
    font-weight: 500;
  }
  .w__input {
    [class*=" w-icon-"], [class^=w-icon-], [class*=" r2-icon-"], [class^=r2-icon-] {
      font-size: 18px !important;
      color: rgba(33, 37, 48, 0.35);
    }
  }

  .w__select__tags {
    .w__tag--info {
      color: rgba(33, 37, 48, 0.8);
      .w__tag__close {
        color: rgba(33, 37, 48, 0.8);
        top: 0 !important;
        &:hover {
          background-color: rgba(33, 37, 48, 0.55) !important;
          color: #ffffff !important;
        }
      }
    }
  }

</style>
